import React, { useCallback, useEffect, useState } from 'react';

// DEPENDENCIES
import { useParams, useNavigate } from 'react-router-dom';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';
import { INTERFACE, RECORD } from 'pathnames.js';

// GLOBAL FUNCTIONS
import { apiFetch, checkRole, makePath } from 'functions.js';

//GLOBAL COMPONENTS
import Preloader from 'parts/preloader/Preloader';

// LOCAL COMPONENTS
import IMVInfo from './parts/IMVInfo';
import IMVResults from './parts/IMVResults';
import InventoryLogs from './parts/InventoryLogs';
import InventoryStatus from './parts/InventoryStatus';
import InventoryButtons from './parts/inventoryButtons/InventoryButtons';
import VehicleManagement from './parts/VehicleManagement';
import PurchaseInfo from './parts/PurchaseInfo';
import InventoryDetail from '../parts/Detail';
import InventoryInternal from '../../../sections/InventoryInternal';
import InventoryAttachments from '../../../sections/InventoryAttachments';
import VehicleInfo from './parts/Vehicleinfo';
import PricingInfo from '../../../sections/PricingInfo';

// MAIN COMPONENT
const InventoryBody = (({ vehicleId }) => {
  const [imvInfo, setImvInfo] = useState({});
  const [imvResult, setImvResult] = useState({});

  const getImvInfoData = useCallback(
    () =>
      apiFetch({
        method: 'GET',
        endpoint: makePath(ENDPOINTS.inventory.imvInfo, vehicleId),
        onSuccess: ({ IMV_Info, IMV_Result }) => {
          setImvInfo(IMV_Info);
          setImvResult(IMV_Result);
        }
      }),
    [vehicleId]
  );

  useEffect(() => {
    const init = async () => {
      await getImvInfoData();
    };

    init();

  }, [getImvInfoData]);

  return (
    <>
      <InventoryStatus />
      <VehicleInfo inventoryId={vehicleId}  />
      <IMVInfo imvInfo={imvInfo} inventoryId={vehicleId} />
      <IMVResults data={imvResult} />
      <PricingInfo />
      <InventoryInternal />
      <PurchaseInfo/>
      <InventoryAttachments />
      <VehicleManagement inventoryId={vehicleId} />
    </>
  );
});

const InventoryView = () => {

  // REACT ROUTER
  const navigate = useNavigate();
  const { recordID } = useParams();

  // STATE
  const [loading, setLoading] = useState(false)

  const goToEdit = checkRole(['dslAdmin', 'inventoryManager', 'salesManager', 'salesManagerPlus'])
    ? () => navigate(makePath(INTERFACE.inventory, RECORD.edit, recordID))
    : undefined;

  return (
    <InventoryDetail
      title="Vehicle Information"
      onEditClick={goToEdit}
      buttons={<InventoryButtons />}
      headerRight={<InventoryLogs />}
      vehicleId={recordID}
      setLoading={setLoading}
    >
      <Preloader loading={loading} useIcon>
        <InventoryBody vehicleId={recordID} />
      </Preloader>
    </InventoryDetail>
  )}


// EXPORT
export default InventoryView;
